module.exports = __webpack_public_path__ + "static/media/add_white.c369a98b.svg";